export const FileConstant = {
    acceptedFiles: ['.jpg', '.jpeg', '.png', '.gif', '.xlsx', '.xls','.xlsm', '.doc', '.docx', '.pdf', '.txt','.msg']
}
